<style>

</style>

<template>
    <Modal
            v-model="showModal"
            :title="title"
            :loading="true"
            :styles="{top: '20px',width:'800px'}"
    >
        <div slot="footer">
            <Button type="text" size="large" @click="modalCancel">取消</Button>
            <Button type="primary" size="large" @click="handleSubmit()" :loading="saving">确定</Button>
        </div>
        <Form :model="formItem" :rules="ruleValidate" :label-width="100" ref="clazzForm"
              @keyup.enter.native="handleSubmit()">
            <Row>
                <Col span="12">
                    <FormItem label="名称" prop="name">
                        <Input v-model.trim="formItem.name" placeholder="请输入班级名称"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="状态" prop="state">
                        <Select v-model="formItem.state" style="width:120px;">
                            <Option :value="1" label="上架"></Option>
                            <Option :value="0" label="下架"></Option>
                        </Select>
                        <Tooltip max-width="200" content="修改状态不影响已排课程,下架后报名时无法再选择该班级">
                            <Icon type="ios-information-circle-outline" :size="14" color="#00c1de"
                                  style="margin-right: 5px;margin-left: 5px;"/>
                        </Tooltip>
                    </FormItem>
                </Col>
            </Row>
            <!--<Row>-->
                <!--<Col span="12">-->
                    <!--<FormItem label="课程起止时间">-->
                        <!--<DatePicker :value="formItem.daterange" type="daterange" split-panels placeholder="选择时间范围" style="width: 300px"-->
                                    <!--format="yyyy-MM-dd" @on-change="formItem.daterange=$event"></DatePicker>-->
                    <!--</FormItem>-->
                <!--</Col>-->
                <!--<Col span="12">-->
                    <!--<FormItem label="课时数">-->
                        <!--<Input v-model="formItem.hours" placeholder="不填则排满，填的话则最多排到对应课时的课"/>-->
                    <!--</FormItem>-->
                <!--</Col>-->
            <!--</Row>-->
            <Row>
                <Col span="12">
                    <FormItem label="校区" prop="zone_id">
                        <Select v-model="formItem.zone_id" :disabled="formItem.id !== null">
                            <Option v-for="zone in zoneList" :value="zone.id" :key="zone.id">{{ zone.name }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="课程" prop="course_id">
                        <Select v-model="formItem.course_id" :disabled="formItem.id !== null">
                            <Option v-for="item in courseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <!--<Col span="12">-->
                    <!--<FormItem label="教师" prop="teacher_id">-->
                        <!--<Select v-model="formItem.teacher_id" filterable style="width: 250px">-->
                            <!--<Option v-for="item in teacherList" :value="item.id" :key="item.id">{{ item.name}}</Option>-->
                        <!--</Select>-->
                    <!--</FormItem>-->
                <!--</Col>-->
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="课时数" prop="hour_num">
                        扣除&nbsp;<Input v-model="formItem.hour_num" placeholder="每次上课扣除课时数" style="width:60px"/>&nbsp;/每次课
                    </FormItem>
                </Col>
            </Row>
            <DateList :dateList="formItem.dateList" v-if="formItem.id === null"></DateList>
            <Alert v-if="formItem.id !== null">日程信息不可编辑，如需修改日程，请在排课模块操作</Alert>
        </Form>
    </Modal>
</template>
<script>

  import DateList from '../common/datelist.vue';

  export default {
    name: 'clazz-form',
    data() {
      return {
        title: '',
        showModal: false,
        saving: false,
        formItem: {
          id: null,
          name:null,
          state: 1,
          hour_num:1,
          // daterange: null,
          // hours: null,
          zone_id: null,
          course_id: null,
          dateList:[]
          // timeList: []
        },
        ruleValidate: {}
      }
    },
    mounted() {
    },
    activated() {
    },
    methods: {
      packagingFormData() {
        let self = this;
        let postFormData = {};
        postFormData['eduClass.id'] = self.formItem.id;
        postFormData['eduClass.name'] = self.formItem.name;
        postFormData['eduClass.zone_id'] = self.formItem.zone_id;
        postFormData['eduClass.course_id'] = self.formItem.course_id;
        postFormData['eduClass.hour_num'] = self.formItem.hour_num;
        // postFormData['eduClass.teacher_id'] = self.formItem.teacher_id;
        // postFormData['eduClass.hours'] = self.formItem.hours;
        postFormData['eduClass.state'] = self.formItem.state;
        // postFormData['eduClass.begin_date'] = self.formItem.daterange[0];
        // postFormData['eduClass.end_date'] = self.formItem.daterange[1];

        if (!self.formItem.id){
          let dateListData = [];
          self.formItem.dateList.forEach(ele => {
            let dateObj = {};
            dateObj.hours = ele.hours;
            dateObj.teacher_id = ele.teacher_id;
            dateObj.begin_date = ele.daterange[0];
            dateObj.end_date = ele.daterange[1];

            let timeListData = [];
            ele.timeList.forEach(ele2 => {
              ele2.weekday.sort();
              let one = {...ele2};
              one.weekday = one.weekday.join(',');
              timeListData.push(one);
            });
            dateObj.timeList = timeListData;

            dateListData.push(dateObj);
          });
          postFormData['dateList'] = JSON.stringify(dateListData);
        }

        return postFormData;
      },
      handleReset(name) {
        this.$refs[name].resetFields();
      },
      modalCancel() {
        this.showModal = false;
        // this.$refs['userForm'].resetFields();
      },
      checkForm() {
        let self = this;
        if (!self.formItem.name) {
          self.$Message.error("班级名称不能为空");
          return false;
        }

        if (!self.formItem.zone_id) {
          self.$Message.error("校区不能为空");
          return false;
        }

        if (!self.formItem.course_id) {
          self.$Message.error("课程不能为空");
          return false;
        }

        if (!self.formItem.hour_num) {
          self.$Message.error("每次扣除课时数不能为空");
          return false;
        }

        if (self.formItem.dateList.length > 0) {
          let checkDate = true;
          self.formItem.dateList.forEach((ele, idx) => {
            if (!ele.daterange) {
              checkDate = false;
              self.$Message.error("开始结束日期不能为空");
              return false;
            }

            if (!ele.teacher_id) {
              checkDate = false;
              self.$Message.error("教师不能为空");
              return false;
            }

            if (ele.timeList.length == 0) {
              checkDate = false;
              self.$Message.error("请增加上课时间");
              return false;
            }

            let checkTime = true;
            ele.timeList.forEach((ele2, idx) => {
              if (!ele2.start) {
                checkTime = false;
                return false;
              }
              if (!ele2.end) {
                checkTime = false;
                return false;
              }
              if (ele2.weekday.length == 0) {
                checkTime = false;
                return false;
              }
            });

            if (!checkTime) {
              checkDate = false;
              self.$Message.error("日程设置错误，星期数和时间段不能为空");
              return false;
            }

            return true;
          });
          if (!checkDate){
            return false;
          }
        }
        return true;
      },
      handleSubmit() {
        let self = this;

        if (self.checkForm()) {
          self.saving = true;
          self.$api.clazz.save(self.packagingFormData()).then(resp => {
            if (resp.state == 'ok') {
              this.$Message.info({
                content: '保存成功',
                onClose() {
                  self.showModal = false;
                  self.$emit('success');
                }
              });
              self.saving = false;

            } else {
              self.saving = false;
              self.$Message.error(resp.msg);
            }
          });
        }
      },
      loadInfo(id, callback) {
        let self = this;
        self.$api.clazz.findOne({id: id}).then(resp => {
          if (resp.state == 'ok') {
            self.formItem.id = resp.data.id;
            self.formItem.name = resp.data.name;
            self.formItem.state = resp.data.state;
            self.formItem.hours = resp.data.hours;
            self.formItem.hour_num = resp.data.hour_num;
            self.formItem.zone_id = resp.data.zone_id;
            self.formItem.course_id = resp.data.course_id;
            self.formItem.teacher_id = resp.data.teacher_id;
            self.formItem.daterange = [ resp.data.begin_date,resp.data.end_date ];
            if (resp.data.timeList){
              let timeList = [];
              resp.data.timeList.forEach(ele=>{
                let one = {
                  weekday : ele.weekday,
                  start:ele.start,
                  end:ele.end
                };

                let weekdayArray = one.weekday.split(',');
                weekdayArray.forEach((ele2,idx)=>{
                  weekdayArray[idx] = parseInt(ele2);
                })
                one.weekday = weekdayArray;
                timeList.push(one);
              });
              self.formItem.timeList = timeList;
            }

            callback && callback();
          } else {
            self.$Message.error(resp.msg);
          }
        });
      },
      showWin(id) {
        let self = this;

        this.formItem = {
          id: null,
          name: null,
          state: 1,
          daterange: null,
          hours: null,
          hour_num:1,
          zone_id: null,
          course_id: null,
          teacher_id: null,
          dateList:[]
        };

        self.saving = false;
        if (id) {
          self.title = '修改班级';
          self.editMode = 'edit';
          self.loadInfo(id, function () {
            self.showModal = true;
          });
        } else {
          self.formItem.id = null;
          self.title = '新增班级';
          self.editMode = 'add';
          self.showModal = true;
        }
      }
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
      courseList() {
        return this.$store.state.app.classCourseList
      },
    },
    components: {
      DateList
    }
  }
</script>
